export type ViewStringItem<T> = T & { viewString: string };

export enum QuerySelectorType {
	Single,
	Multiple
}